import Vue from 'vue';
import Router from 'vue-router';
import DashboardLayout from '../views/Layout/Layout.vue';
import FleetDrivingStyle from '../views/Dashboard/FleetDrivingStyle.vue';
import EntityDetail from "../views/Dashboard/EntityDetail.vue";
import EntityTrips from "../views/DrivingStyle/EntityTrips";
import EntityInterval from "../views/DrivingStyle/EntityInterval";
import EntityHeatmap from "../views/DrivingStyle/EntityHeatmap";
import Login from "../views/Login/Login";
import ConfigurationGroupConfigurations from "../views/Management/ConfigurationGroupConfigurations";
import FleetOverview from "../views/Dashboard/FleetOverview";
import ControlRoom from "../views/ControlRoom/MonitoringView";

// Management pages
const Admin = () => import('../views/OEM/Admin.vue')
const Synchronization = () => import('../views/Management/Synchronization.vue')
const FailedSynchronizations = () => import('../views/OEM/FailedSyncs.vue')
const CrudOverview = () => import('../views/Management/CrudOverview.vue')
const CrudList = () => import('../views/Management/CrudList.vue')
const CrudMember = () => import('../views/Management/CrudMember.vue')
const CrudEdit = () => import('../views/Management/CrudEdit.vue')
const CrudLink = () => import('../views/Management/CrudLink.vue')
const OrganisationSettings = () => import('../views/Management/OrganisationSettings.vue')

let assetRoutes = {
  path: '/entities',
  component: DashboardLayout,
  redirect: '/assets/overview',
  name: 'Entities',
  children: [
    {
      path: 'asset-detail',
      name: 'asset-detail',
      component: EntityDetail,
      props: true
    },
    {
      path: 'driver-detail',
      name: 'driver-detail',
      component: EntityDetail,
      props: true
    },
    {
      path: 'entity-trips',
      name: 'entity-trips',
      component: EntityTrips,
      props: true
    },
    {
      path: 'entity-interval',
      name: 'entity-interval',
      component: EntityInterval,
      props: true
    },
    {
      path: 'entity-heatmap',
      name: 'entity-heatmap',
      component: EntityHeatmap,
      props: true
    }
  ]
}

let managementRoutes = {
  path: '/management',
  component: DashboardLayout,
  redirect: '/management/assets',
  name: 'Management',
  children: [
    {
      path: 'organisationsettings',
      name: 'organisationsettings',
      component: OrganisationSettings
    },
    {
      path: 'synchronization',
      name: 'synchronization',
      component: Synchronization
    },
    {
      path: 'overview',
      name: 'overview',
      component: CrudOverview
    },
    {
      path: 'assets',
      name: 'assets',
      component: CrudList
    },
    {
      path: 'devices',
      name: 'devices',
      component: CrudList
    },
    {
      path: 'drivers',
      name: 'drivers',
      component: CrudList
    },
    {
      path: 'groups',
      name: 'groups',
      component: CrudList
    },
    {
      path: 'configurationgroups',
      name: 'configurationgroups',
      component: CrudList
    },
    {
      path: 'users',
      name: 'users',
      component: CrudList
    },
    {
      path: 'entity/edit',
      name: 'entity-edit',
      component: CrudEdit,
      props: true
    },
    {
      path: 'entity/members',
      name: 'entity-members',
      component: CrudMember,
      props: true
    },
    {
      path: 'entity/links',
      name: 'entity-links',
      component: CrudLink,
      props: true
    },
    {
      path: 'entity/configs',
      name: 'entity-configs',
      component: ConfigurationGroupConfigurations,
      props: true
    }
  ]
};

let oemRoutes = {
  path: '/oem',
  component: DashboardLayout,
  redirect: '/oem/organisations',
  name: 'OEM',
  children: [
    {
      path: 'admin',
      name: 'admin',
      component: Admin
    },
    {
      path: 'organisations',
      name: 'organisations',
      component: CrudList
    },
    {
      path: 'failedsynchronizations',
      name: 'failedsynchronizations',
      component: FailedSynchronizations
    },
  ]
}

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: '/login',
      component: DashboardLayout,
      children: [
        {
          path: '/overview',
          name: 'overview',
          component: FleetOverview
        },
        {
          path: '/drivingstyle',
          name: 'drivingstyle',
          component: FleetDrivingStyle
        }
      ]
    },
    {
      path: '/login',
      component: Login
    },
    {
      path: '/monitoring',
      name: 'monitoring',
      component: ControlRoom
    },
    managementRoutes,
    assetRoutes,
    oemRoutes
  ],
  scrollBehavior: (to, from ,savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  }

});

